import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DummyStorageService {
  private store = {};

  public clear(): void {
    this.store = {};
  }

  public getItem(key: string): string {
    return key in this.store ? this.store[key] : null;
  }

  public removeItem(key: string): void {
    delete this.store[key];
  }

  public setItem(key: string, value: string): void {
    this.store[key] = value;
  }
}
